const cssVariables = () => {
  const headerWrapper = document.querySelector('.header__wrapper');
  const promo = document.querySelector('.promo');

  if (promo) {
    const setMainBackground = () => {
      promo.style.setProperty('--headerHeight', headerWrapper.offsetHeight + 4 + 'px');
    };


    setMainBackground();

    window.addEventListener('resize', function () {
      setMainBackground();
    });
  }

  const innerPromo = document.querySelector('.inner-promo');
  const coordinator = document.querySelector('.coordinator');

  if (innerPromo && coordinator) {
    const innerPromoLink = innerPromo.querySelector('.link-arrow');
    const setPromoLinkArrow = () => {
      innerPromoLink.style.setProperty('--linkArrowLeft', coordinator.getBoundingClientRect().left - 75 + 'px');
    };

    setPromoLinkArrow();

    window.addEventListener('resize', function () {
      setPromoLinkArrow();
    });
  }
};

export {cssVariables};
